module.exports = __webpack_public_path__ + "static/media/gccs_logo_image.5ea0fe74.svg";